import { Link } from 'react-router-dom';
import './css/breadcrumb.css';

const Breadcrumb = ({ breadcrumb }) => {
  return (
    <section className="bg-breadcrumb ">
      <div className="container">
        <div className="row breadcrumb">
          <div className="col-12">
            <div className="d-flex icon mt-auto">
              <i className="fas fa-home" style={{ fontSize: '20px' }}></i>
              <div className="link">
                <Link className="link-breadcrumb" to="/" title="Trang chủ">
                  Trang chủ
                </Link>
                /
                <Link
                  className="link-breadcrumb"
                  to={`/${breadcrumb.slug}`}
                  title={breadcrumb.title}
                >
                  {breadcrumb.title}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Breadcrumb;
